import { HelpContentContainer } from ".";
import { ModalHeader } from "@/components/Modal/ModalHeader";
import { HotkeysTable } from "@/components/Modals/HelpGuideModal/HotkeysTable";
import { AppText } from "@/components/Text/AppText";

interface HelpGuideHotkeysProps {
    onClose: () => void;
}

export const HelpGuideHotkeys = ({ onClose }: HelpGuideHotkeysProps) => {
    return (
        <div>
            <ModalHeader
                title="Hotkeys"
                onClose={onClose}
            />
            <HelpContentContainer>
                <AppText variant="regular">
                    With text highlighted within a section, you can use the
                    following hotkeys to format your text:
                </AppText>
                <div className="relative mt-4 h-[450px] overflow-y-scroll">
                    <HotkeysTable />
                </div>
            </HelpContentContainer>
        </div>
    );
};
